import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Toggle from 'material-ui/Toggle'
import { toggleCallerId } from '../../state/actions/account'
import BrowserSpecificPopover from './BrowserSpecificPopover'
import css from './styles.css'


const styles = {
  notificationToggle: {
    position: 'absolute',
    top: '28px',
    right: '140px',
    width: '275px',
  },
}

class NotificationToggle extends Component {
  static propTypes = {
    clickToggle: PropTypes.func,
    callerIdEnabled: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      showPopover: false,
      permission: Notification.permission,
    }
  }

  componentDidUpdate() {
    if (Notification.permission !== this.state.permission) {
      this.setBrowserNotificationState()
    }
  }

  setBrowserNotificationState = () => {
    this.setState({ permission: Notification.permission })
  }

  handleMouseEnter = () => {
    if (Notification.permission === 'denied') {
      this.setState({ showPopover: true })
    }
  }

  handleMouseLeave = () => {
    this.setState({ showPopover: false })
  }

  handleToggle = () => {
    const { clickToggle, callerIdEnabled } = this.props
    const { permission } = this.state

    if (permission === 'default') {
      Notification.requestPermission()
        .then(() => { this.updateIfToggleMatchesCallEnabledState() })
    } else { clickToggle(callerIdEnabled) }
  }

  // This is to prevent state/backend updates when browser notifications haven't been set
  // but callerIdEnabled === true (ie. a mismatch between state and display)
  updateIfToggleMatchesCallEnabledState = () => {
    const { clickToggle, callerIdEnabled } = this.props

    if (!callerIdEnabled) { clickToggle(callerIdEnabled) }
    this.setBrowserNotificationState()
  }

  render() {
    const { callerIdEnabled } = this.props
    const { showPopover, permission } = this.state
    const hoverTextStyles = cx(css.textBox, { [css.show]: showPopover })

    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <Toggle
          id="callerIdNotificationToggle"
          toggled={permission === 'granted' && callerIdEnabled}
          label="Call/Message Notifications"
          disabled={permission === 'denied'}
          style={styles.notificationToggle}
          onToggle={this.handleToggle}
        />
        <div className={hoverTextStyles} >
          <BrowserSpecificPopover />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ account }) => ({
  callerIdEnabled: account.user.callerIdEnabled,
})

const mapDispatchToProps = dispatch => ({
  clickToggle: callerIdEnabled => dispatch(toggleCallerId(callerIdEnabled)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationToggle)



// WEBPACK FOOTER //
// ./src/components/Account/NotificationToggle.js